<div class="sync-fusion-main-container">
  <div class="fs-section-block fs-margin-0 header-background ">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <span class="mat-headline">Merchandising template</span>
        <p class="fs-hint-text mt-1">Assign shelf space strategically by product traits</p>
      </div>
      <button color="primary" mat-raised-button (click)="showCreateLevelInput = !showCreateLevelInput"> Create
        Template</button>
    </div>
  </div>
  <div class="level-container">
    <div *ngIf="showCreateLevelInput" class="create-level-container">
      <input type="text" [(ngModel)]="newLevelName" placeholder="Merchandising Template Name" class="level-input">
      <!-- <input type="text" [(ngModel)]="newLevelAttribute" placeholder="Enter Attribute (e.g., CategoryL1, CategoryL2)" class="level-input"> -->
      <mat-form-field appearance="outline">
        <mat-label>Select Attribute</mat-label>
        <mat-select [formControl]="selectedAttribute">
          <mat-option *ngFor="let option of dropdownOptions" [value]="option.identifier">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="buttons-create">
        <button class="create-level-button" (click)="createStructure()">Create</button>
        <button class="create-level-button" (click)="showCreateLevelInput = !showCreateLevelInput">Cancel</button>
      </div>
    </div>
    <div class="structures-container">
      <ng-container *ngFor="let level of structures">
        <div class="level-box" (click)="navigateToStructure(level)">
          <p><strong></strong> {{ level.code }}</p>
          <!-- Three-dot Menu Button -->
          <button mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"  class="menu-button" (click)="$event.stopPropagation()">
            <mat-icon>more_vert</mat-icon>
          </button>
          <!-- Menu with Delete Option -->
          <mat-menu #menu="matMenu">
            <button mat-menu-item class="menu-delete" (click)="deleteConfig(level.id); $event.stopPropagation(); menuTrigger.closeMenu()">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
            <button mat-menu-item class="menu-delete" (click)="editName(level); $event.stopPropagation(); menuTrigger.closeMenu()">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
          </mat-menu>
          <div *ngIf="editedLevelId === level.id" class="edit-level-container" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="tempCode" class="level-input" (click)="$event.stopPropagation()">
            <div class="buttons-create">
              <button class="create-level-button" (click)="saveEdit(level);$event.stopPropagation()">Save</button>
              <button class="create-level-button" (click)="cancelEdit();$event.stopPropagation()">Cancel</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>